import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CambridgeProduct, GACategory } from 'src/types';
import { sendGAEvent } from 'src/utils/googleAnalytics';
import useAuth from '../../hooks/useAuth';
import { useStyles } from './styles';

const Product: React.FC<CambridgeProduct> = ({
  title,
  description,
  imageUrl,
  url,
}) => {
  const { user } = useAuth();

  const classes = useStyles();
  const history = useHistory();
  const img = new Image();
  const [backgroundSize, setBackgroundSize] = useState('cover');

  const handleClick = useCallback(() => {
    sendGAEvent(
      GACategory.products,
      `${user.roles} clicked on product tile ${title}`
    );

    if (url.includes('/pda/bookings')) {
      history.push('/pda/bookings');
      return;
    }

    window.location.assign(url);
  }, [user.roles, title, GACategory.products, url]);

  img.src = imageUrl;
  img.onload = () => {
    // for checking if the image size fits the cardMedia container
    if (img.width < 400 && img.height < 400) {
      setBackgroundSize('contain');
    }
  };

  return (
    <Card>
      <CardActionArea onClick={handleClick}>
        <CardMedia
          image={imageUrl}
          // default for backgroundSize is 'cover' but if the image is smaller than 400x400 we set it to 'contain' to make the image fully visible
          style={{ backgroundSize: backgroundSize, height: 200 }}
        />
        <CardContent>
          <CardHeader title={title} />
          <Typography
            className={classes.paragraph}
            variant="body1"
            color="textSecondary"
            dangerouslySetInnerHTML={{ __html: description }}
          ></Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default memo(Product);
